import React, {useCallback, useContext, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {clearSelection} from 'src/components/data-table-selection';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';
import {UserSortField as UserSortFields} from 'src/openapi/admin/models/UserSortField';
import {getMainColumnHeader} from 'src/utils/getMainColumnHeader';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';
import {LocaleContext} from '@pb/kit-context-locale';

import {COLUMNS, HEADERS, SELECTION_KEY} from '../../constants';
import {userSearchResultStateActions, userSearchResultStateSelector} from '../../slices/user-search-result-state.slice';
import {userSearchResultResultSelector} from '../../slices/user-search-result.slice';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

export const EmailHeader = () => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(userSearchResultStateSelector);

    const result = useSelector(userSearchResultResultSelector);
    const {locale} = useContext(LocaleContext);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(clearSelection(SELECTION_KEY));
        dispatch(userSearchResultStateActions.setSortCriteria({
            direction: direction as SortDirection,
            field: UserSortFields.EMAIL,
        }));
    }, [dispatch]);

    const caption = useMemo(
        () => getMainColumnHeader(HEADERS[COLUMNS.EMAIL], locale, result?.totalCount),
        [result?.totalCount, locale],
    );

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === UserSortFields.EMAIL
                ? cacheKeys.sortCriteria.direction
                : null}
            filterActive={true}
            caption={caption}
            onSort={sort}
        />
    );
};
